import React, { useEffect } from 'react';
import clsx from 'clsx';
import { SignOut, User } from 'phosphor-react';
import { CaretRight, Logo, LogoMinimal } from '@gbm-tech/icons';
import { breakpointsInNumber } from '@gbm-tech/styles';

import { SidebarModule } from './dtos';
import { SidebarItemMenu } from './components';

import {
  SidebarActionItem,
  SidebarContainer,
  SidebarMenuActionsContainer,
  SidebarMenuContainer,
} from './styles';

export type SidebarProps = {
  isSidebarOpen: boolean;
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  toggleSidebar: () => void;
  sidebarData: SidebarModule[];
  userName?: string;
  logout?: () => void;
};

export const Sidebar: React.FC<SidebarProps> = ({
  isSidebarOpen,
  toggleSidebar,
  setIsSidebarOpen,
  sidebarData,
  userName,
  logout,
}) => {
  function changeStateSidebar(state: boolean) {
    setIsSidebarOpen(state);
  }

  useEffect(() => {
    window.addEventListener('resize', () => {
      const innerWidth = window.innerWidth;

      if (
        innerWidth >= breakpointsInNumber.lg &&
        innerWidth <= breakpointsInNumber.xxl
      ) {
        changeStateSidebar(false);
      }
    });
  }, []);

  return (
    <SidebarContainer isOpen={isSidebarOpen}>
      <header>
        <div className="logo">
          <div
            className={clsx('image normal', {
              visible: isSidebarOpen,
            })}
          >
            <Logo />
          </div>

          <div
            className={clsx('image minimal', {
              visible: !isSidebarOpen,
            })}
          >
            <LogoMinimal />
          </div>
        </div>

        <button onClick={toggleSidebar}>
          <CaretRight />
        </button>
      </header>

      <SidebarMenuContainer>
        {sidebarData?.map((module) => (
          <SidebarItemMenu
            key={`module-sidebar-${module.id}`}
            isSidebarOpen={isSidebarOpen}
            module={module}
          />
        ))}
      </SidebarMenuContainer>

      <SidebarMenuActionsContainer>
        <SidebarActionItem isSidebarOpen={isSidebarOpen} onClick={logout}>
          <div className="icon">
            <SignOut weight="regular" />
          </div>

          <span title="Sair">Sair</span>
        </SidebarActionItem>

        <SidebarActionItem isSidebarOpen={isSidebarOpen}>
          <div className="icon">
            <User weight="regular" />
          </div>

          <span title={userName}>{userName}</span>
        </SidebarActionItem>
      </SidebarMenuActionsContainer>
    </SidebarContainer>
  );
};

export default Sidebar;
